import { SUB_NAV_MENU_LIST } from "./ArrayData"
import { categoriesList } from "./category/dico"

export const VAR_LOGIN = "Connexion"
export const VAR_MODEL_NAME = "ModelName"
export const VAR_CAMPAIGN = "Campagne"
export const VAR_DASHBOARD = "Dashboard"
export const VAR_TEACHER = "Stratège"
export const VAR_LEVEL = "Level Up"
export const VAR_CRM = "CRM"
export const VAR_TARIFS = "Tarifs"
export const VAR_ADMIN = "Manager"

export const VAR_CAMPAIGN_HISTORY = "History"
export const VAR_CAMPAIGN_CHART = "Suivi"
export const VAR_CRM_HOME = "Accueil-CRM"
export const VAR_CRM_CHOICE = "Configuration"
export const VAR_CRM_DETAILS = "Recapitulation"

export const CAMPAIGN_TEXT_VALIDATION = "CLSOK"

export const CAMPAIGN_BASE_ROUTE = `${VAR_MODEL_NAME}/${VAR_CAMPAIGN}`
export const DASHBOARD_BASE_ROUTE = `${VAR_MODEL_NAME}/${VAR_DASHBOARD}`

export const FIRST_PAGE = SUB_NAV_MENU_LIST[0]
export const FIRST_MENU4PAGE = VAR_CAMPAIGN

export const SENDER_EMAIL_ADDR = "aurelia@giris.fr"

export const VAR_SALES_NAV = "sales-navigator"

export const VAR_TREE = "arborescence"

export const VAR_SURFER = "surfer"

export const default_mail_segment_key = "accroche"
export const default_criteria = "pertinence"
export const default_post_category = categoriesList[0]
export const default_question = "L’accroche mentionne-t-elle le post que la personne a publié sur LinkedIn ?"

export const default_credit = 100